import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "home-section",
  id: "vs-home-contact"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "home-contact-title" }, "Fale conosco", -1)
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "home-contact-form-submit button is-primary",
  type: "submit"
}, "Enviar mensagem", -1)

import { ref, watch } from "vue";
import { useStore } from "vuex";
import { formatPhone, removePhoneMask } from "@/libs/utils";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

function getInitialForm() {
  return { nm_usuario: "", ds_email: "", nr_telefone: "", ds_mensagem: "" };
}

const form = ref(getInitialForm());

async function handleSubmit() {
  function handlePhoneNumber() {
    const nr_telefone = removePhoneMask(form.value.nr_telefone);
    if (!nr_telefone.includes("+")) return `+55${nr_telefone}`;
    return nr_telefone;
  }

  const response = await store.dispatch("userContactUs", {
    form: { ...form.value, nr_telefone: handlePhoneNumber() },
  });
  if ((response?.status || 0) < 300) {
    store.commit("addToast", {
      summary: "O seu e-mail foi cadastrado com sucesso, aguarde nossa equipe entrar em contato!",
      severity: "success",
    });

    form.value = getInitialForm();
  }
}

watch(
  () => form.value.nr_telefone,
  (value) => {
    form.value.nr_telefone = formatPhone(value);
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      class: "home-contact-form",
      onSubmit: _withModifiers(handleSubmit, ["prevent"])
    }, [
      _withDirectives(_createElementVNode("input", {
        class: "input",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.nm_usuario) = $event)),
        placeholder: "Nome completo",
        required: ""
      }, null, 512), [
        [_vModelText, form.value.nm_usuario]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "input",
        type: "email",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.ds_email) = $event)),
        placeholder: "E-mail",
        required: ""
      }, null, 512), [
        [_vModelText, form.value.ds_email]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "input",
        type: "tel",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.nr_telefone) = $event)),
        placeholder: "Telefone",
        required: ""
      }, null, 512), [
        [_vModelText, form.value.nr_telefone]
      ]),
      _withDirectives(_createElementVNode("textarea", {
        class: "textarea",
        rows: "4",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.ds_mensagem) = $event)),
        placeholder: "Mensagem",
        required: ""
      }, null, 512), [
        [_vModelText, form.value.ds_mensagem]
      ]),
      _hoisted_4
    ], 40, _hoisted_3)
  ]))
}
}

})